import React from 'react';
import MenuItem from './MenuItem';
import PropTypes from "prop-types";

const valueOrDefault = (value, defaultValue) => {
    if ( value == undefined ) {
        return defaultValue;
    }
    return value;
};

const SESSION_STORAGE_OPEN_SUB_MENU_ITEM = "uniNav.openSubMenuItem";

class SubMenuList extends React.Component {
    constructor(props){
      super(props);
      this.state = {
        menuOpen: false,
        openItem: valueOrDefault(sessionStorage.getItem(SESSION_STORAGE_OPEN_SUB_MENU_ITEM), ''),
        collapseAll: true
      };

      this.onToggleMenu = this.onToggleMenu.bind(this);
    }

    onToggleMenu(t){
        if(t.props.menuOpen === true) {
            sessionStorage.setItem(SESSION_STORAGE_OPEN_SUB_MENU_ITEM, '');
            this.setState({ menuOpen: false, openItem: '' });
        } else {
            sessionStorage.setItem(SESSION_STORAGE_OPEN_SUB_MENU_ITEM, t.props.item.name);
            this.setState({ openItem: t.props.item.name });
        }
    }

    render() {
        if(this.props.subMenu){
            const listItems = this.props.subMenu.map((item, idx) =>
                 <MenuItem  handleClose={ this.props.handleClose} onMenuToggle={this.onToggleMenu} menuOpen={item.name === this.state.openItem ? true : false} subItem="true" item={item} key={idx}></MenuItem>
            );
            return (
                <ul id="uniNavSubMenu" className="uniNav-sub-menu">
                    {listItems}
                </ul>
            );
        }
        return null;
    }
}

SubMenuList.propTypes = {
    subMenu: PropTypes.array.isRequired,
    drawerOpen: PropTypes.bool,
    handleClose: PropTypes.func
};

export default SubMenuList;
